import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from 'src/app/modules/_models/field.interface';
@Component({
    selector: 'app-card-conteudo',
    template: `
    <div class="conteudo_container">
      <div class="imagem_container">
        <img class="imagem" [src]="field.src">
      </div>
      <div class="conteudo_footer image_rectangle58">
        <label for="" class="cs_label label_descricao"
            [innerHTML]="field.label | linkify">
        </label>
        <button class="conteudo_button" (click)="irParaPagina(field)" [ngClass]="{'item-clicavel': field.singleLink}" 
            [disabled]="!field.singleLink">
          <span class="fa" [ngClass]="field.mainIcon ? field.mainIcon : 'fa-shopping-cart'"></span>
          <label class="cs_label label_button" [ngClass]="{'item-clicavel': field.singleLink}" >{{ field.singleLink ? 'Acesse o site' : 'Disponível nas lojas' }}</label>
        </button>
      </div>
    </div>
  `,
    styleUrls: ['./card-conteudo.component.scss']
})
export class CardConteudoComponent implements OnInit {
    field: FieldConfig;
    group: UntypedFormGroup;
    constructor() { }
    ngOnInit(): void { }
    irParaPagina(field: any) {
        if (field.singleLink) {
            window.open(field.singleLink, "_blank");
        }
    }
}
